/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    IOLinesMode,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';

export const getCodeBlocks = (feature: BaseTibbit): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const X_AXIS_NAME = feature.getSettingValue('X_AXIS_NAME');
    const Y_AXIS_NAME = feature.getSettingValue('Y_AXIS_NAME');
    const Z_AXIS_NAME = feature.getSettingValue('Z_AXIS_NAME');
    const NAME = `${X_AXIS_NAME}_${Y_AXIS_NAME}_${Z_AXIS_NAME}`;
    const { project } = feature;
    const ID = feature.getID();
    const connectedSocket = (Number(feature.getSettingValue('SOCKET')) - 1).toString();

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
'Tibbit 00_3 with tibbit 36
if tbt36_init("${NAME}",NO,S${connectedSocket}_${NAME}_CLK,S${connectedSocket}_${NAME}_DATA,${NAME}_CHANNEL_NUM)=NG then
sys.debugprint("SSI channel could not be allocated, using bit banging instead."+chr(10)+chr(13))
end if`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare ${NAME}_CHANNEL_NUM as byte`,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim ${NAME}_CHANNEL_NUM as byte`,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: `
dim ${X_AXIS_NAME}_tmp,${Y_AXIS_NAME}_tmp,${Z_AXIS_NAME}_tmp as integer

tbt36_get_mg(${X_AXIS_NAME}_tmp,${Y_AXIS_NAME}_tmp,${Z_AXIS_NAME}_tmp,${NAME}_CHANNEL_NUM)
var_${X_AXIS_NAME}_update_completed(${X_AXIS_NAME}_tmp)
var_${Y_AXIS_NAME}_update_completed(${Y_AXIS_NAME}_tmp)
var_${Z_AXIS_NAME}_update_completed(${Z_AXIS_NAME}_tmp)
`,
    });

    blocks.push({
        location: 'GLOBAL_CONSTS',
        blockType: BlockType.CODE,
        template: `
const S${connectedSocket}_${NAME}_CLK = ${Tibbits.getSocketPins(connectedSocket, feature.project.device.id)[0]}
const S${connectedSocket}_${NAME}_DATA = ${Tibbits.getSocketPins(connectedSocket, feature.project.device.id)[1]}`,
    });
    return blocks;
};
